import { render, staticRenderFns } from "./Politicas.vue?vue&type=template&id=103412a5&scoped=true&"
import script from "./Politicas.vue?vue&type=script&lang=js&"
export * from "./Politicas.vue?vue&type=script&lang=js&"
import style0 from "./Politicas.vue?vue&type=style&index=0&id=103412a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103412a5",
  null
  
)

export default component.exports